import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BackendService } from './backend.service';
import { getLogger } from 'src/shared/logging';
import firebase from 'firebase/compat/app';

const log = getLogger("UserManagementService");

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  // #region Constructors (1)

  constructor(
    private afs: AngularFirestore
  ) { }

  // #endregion Constructors (1)

  // #region Public Methods (2)

  /**
   * Updates the list of `sharedWith` on a TextableUser object by calling the
   * backend endpoint authenticated by the curent Firebase user's token
   *
   * @param id UID of the user to update
   * @param sharedWith The full array of UIDs with whom the user's number should be shared
   * @returns
   */
  public async addUserDeviceToken(id: string, newDeviceToken: string) {
    try {
      await this.afs.doc("users/" + id).update({
        deviceTokens: firebase.firestore.FieldValue.arrayUnion(newDeviceToken)
      });
      log.debug("Added user device token ", newDeviceToken)
    } catch (err) {
      throw new Error("Error adding deviceTokens for user: " + err.error.error);
    }
  }

  /**
   * Updates the list of `sharedWith` on a TextableUser object by calling the
   * backend endpoint authenticated by the curent Firebase user's token
   *
   * @param id UID of the user to update
   * @param sharedWith The full array of UIDs with whom the user's number should be shared
   * @returns
   */
  public async removeUserDeviceToken(id: string, oldDeviceToken: string) {
      try {
        await this.afs.doc("users/" + id).update({
          deviceTokens:  firebase.firestore.FieldValue.arrayRemove(oldDeviceToken)
        });
        log.debug("Removed user device token ", oldDeviceToken)
      } catch (err) {
        throw new Error("Error removing deviceTokens for user: " + err);
      }
    }

  // #endregion Public Methods (2)
}
